import { axiosMockAdapterInstance } from "apis";
import { getResponseData } from "mocksdata/index";

const systemBalancesData = [
  {
    _id: "62726956468160091a24259e",
    currentStep: 3,
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    userType: 1,
    status: 1,
    localCurrency: "USD",
    fizenpayFeePerc: 0.7,
    lastWithdrawal: [
      {
        "usdt-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "usdc-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "busd-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "eth-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "dai-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "ada-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "luna-bsc": "2022-05-05T04:10:11.692Z",
      },
      {
        "shib-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "doge-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "xrp-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "bnb-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "eth-eth": "2022-05-04T11:53:58.460Z",
      },
      {
        "dot-eth": "2022-05-04T11:53:58.460Z",
      },
    ],
    nextWithdrawal: [
      {
        "usdt-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "usdc-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "busd-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "eth-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "dai-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "ada-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "luna-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "shib-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "doge-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "xrp-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "bnb-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "eth-eth": "2022-05-04T11:53:58.460Z",
      },
      {
        "dot-eth": "2022-05-04T11:53:58.460Z",
      },
    ],
    email: "hoanh01@sotanext.com",
    supportEmail: "hoanh01@sotanext.com",
    password: "$2b$10$54H56vpX7HT5Ed1Zg73Yj.ROMdW9P.TVW5RLQ84c98gzApQdi5wF6",
    provider: 1,
    activateCode: "KZF73SEccD1y8qnLyKBsnsvFeGgVyXoq",
    security: {
      is2faEnabled: false,
      isEmailVerifyEnabled: false,
      secret: null,
      tmpSecret: null,
      emailCode: null,
      emailCodeExp: 0,
    },
    flexiblePaymentSettings: {
      type: 0,
      underPaymentThresholdValue: 0.1,
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: 5,
      overPaymentCurrency: "USD",
    },
    backupCode: [
      "Phrwu5FPoQ",
      "sKjaQrQOpm",
      "VUFtioJjff",
      "OtdiVrdslo",
      "vOg3PFz8g_",
      "wtj5SkDjgm",
      "kTtQqyYWL9",
      "HJswp4ZFqA",
      "GGeHbjISvO",
      "G-oBFmF8kh",
    ],
    cryptoCurrencySettings: {
      name: "LUNA",
      slug: "luna-bsc",
      network: "binance-smart-chain-testnet",
      address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
      cmcId: 4172,
      decimal: 18,
      type: ["POPULAR"],
      gasLimit: 70871,
      status: "ACTIVE",
      isEnabled: true,
      confirmedBalance: "100",
      unconfirmedBalance: "0",
      fizenFeeBalance: "0.000001",
      withdrawTokenStatus: "INACTIVE",
      autoWithdrawalStatus: "INACTIVE",
      withdrawalHistory: "6273a58e1b3085038beab947",
    },
    sharedSecret: "UH82UV48ZAJ2",
    createdAt: "2022-05-04T11:53:58.475Z",
    updatedAt: "2022-05-06T09:21:05.524Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: 0,
      startTime: "2022-05-04T11:57:10.470Z",
      endTime: "2022-05-04T11:57:10.470Z",
    },
    id: "62726956468160091a24259e",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/4baeff1f3e7879241769ffe5/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/4baeff1f3e7879241769ffe5/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        contract: "0x9dDE922A9e47455a0Deb50a3f23B77C3BB6b0B56",
        address: "0xCEb99Bf434b7F93432586eDE0739F799F532FD10",
      },
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "ETH",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/4baeff1f3e7879241769ffe5/eth/rinkeby",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/4baeff1f3e7879241769ffe5/eth/rinkeby/ws",
        network: "ethereum-rinkeby",
        fpMasterContract: "0xB4Cc94174a9FBeE8cC9B40FccBA6F77a6464B5d8",
        transactionUrl: "https://rinkeby.etherscan.io/tx/",
        contract: "0x0E3296951C299014A09a942571FF007c503a4f24",
        address: "0xCEb99Bf434b7F93432586eDE0739F799F532FD10",
      },
    ],
    chains: null,
    cryptoCurrency: null,
    forgotPassword: null,
    name: null,
    rejectReason: null,
    feeValueInFiat: "3.431517061399034716488809817684",
  },
  {
    _id: "62726956468160091a24279e",
    currentStep: 3,
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    userType: 1,
    status: 1,
    localCurrency: "USD",
    fizenpayFeePerc: 0.7,
    lastWithdrawal: [
      {
        "usdt-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "usdc-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "busd-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "eth-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "dai-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "ada-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "luna-bsc": "2022-05-05T04:10:11.692Z",
      },
      {
        "shib-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "doge-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "xrp-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "bnb-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "eth-eth": "2022-05-04T11:53:58.460Z",
      },
      {
        "dot-eth": "2022-05-04T11:53:58.460Z",
      },
    ],
    nextWithdrawal: [
      {
        "usdt-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "usdc-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "busd-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "eth-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "dai-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "ada-bsc": "2022-05-04T11:53:58.459Z",
      },
      {
        "luna-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "shib-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "doge-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "xrp-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "bnb-bsc": "2022-05-04T11:53:58.460Z",
      },
      {
        "eth-eth": "2022-05-04T11:53:58.460Z",
      },
      {
        "dot-eth": "2022-05-04T11:53:58.460Z",
      },
    ],
    email: "hoanh01@sotanext.com",
    supportEmail: "hoanh01@sotanext.com",
    password: "$2b$10$54H56vpX7HT5Ed1Zg73Yj.ROMdW9P.TVW5RLQ84c98gzApQdi5wF6",
    provider: 1,
    activateCode: "KZF73SEccD1y8qnLyKBsnsvFeGgVyXoq",
    security: {
      is2faEnabled: false,
      isEmailVerifyEnabled: false,
      secret: null,
      tmpSecret: null,
      emailCode: null,
      emailCodeExp: 0,
    },
    flexiblePaymentSettings: {
      type: 0,
      underPaymentThresholdValue: 0.1,
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: 5,
      overPaymentCurrency: "USD",
    },
    backupCode: [
      "Phrwu5FPoQ",
      "sKjaQrQOpm",
      "VUFtioJjff",
      "OtdiVrdslo",
      "vOg3PFz8g_",
      "wtj5SkDjgm",
      "kTtQqyYWL9",
      "HJswp4ZFqA",
      "GGeHbjISvO",
      "G-oBFmF8kh",
    ],
    cryptoCurrencySettings: {
      name: "LUNA",
      slug: "luna-bsc",
      network: "binance-smart-chain-testnet",
      address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
      cmcId: 4172,
      decimal: 18,
      type: ["POPULAR"],
      gasLimit: 70871,
      status: "ACTIVE",
      isEnabled: true,
      confirmedBalance: "100",
      unconfirmedBalance: "0",
      fizenFeeBalance: "0.035738771808884184",
      withdrawTokenStatus: "INACTIVE",
      autoWithdrawalStatus: "INACTIVE",
      withdrawalHistory: "6273a58e1b3085038beab947",
    },
    sharedSecret: "UH82UV48ZAJ2",
    createdAt: "2022-05-04T11:53:58.475Z",
    updatedAt: "2022-05-06T09:21:05.524Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: 0,
      startTime: "2022-05-04T11:57:10.470Z",
      endTime: "2022-05-04T11:57:10.470Z",
    },
    id: "62726956468160091a24279e",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/4baeff1f3e7879241769ffe5/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/4baeff1f3e7879241769ffe5/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        contract: "0x9dDE922A9e47455a0Deb50a3f23B77C3BB6b0B56",
        address: "0xCEb99Bf434b7F93132586eDE0739F799F532FD10",
      },
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "ETH",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/4baeff1f3e7879241769ffe5/eth/rinkeby",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/4baeff1f3e7879241769ffe5/eth/rinkeby/ws",
        network: "ethereum-rinkeby",
        fpMasterContract: "0xB4Cc94174a9FBeE8cC9B40FccBA6F77a6464B5d8",
        transactionUrl: "https://rinkeby.etherscan.io/tx/",
        contract: "0x0E3296951C299014A09a942571FF007c503a4f24",
        address: "0xCEb99Bf434b7F93132586eDE0739F799F532FD10",
      },
    ],
    chains: null,
    cryptoCurrency: null,
    forgotPassword: null,
    name: null,
    rejectReason: null,
    feeValueInFiat: "3.431517061399034716488809817684",
  },
];

export const onGetSystemBalances = () => {
  axiosMockAdapterInstance.onGet("/merchants/service-fee").reply(() => {
    return [200, getResponseData(systemBalancesData)];
  });
};
export const onPostSystemBalances = (data) => {
  axiosMockAdapterInstance.onPost("/merchants/service-fee").reply(() => {
    return [200, getResponseData(data)];
  });
};
